import axiosInstance from "./axios";
import { Invoice } from "./models/invoices.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchInvoices = async (
  bearerToken: string,
  companyId: number,
): Promise<Invoice[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Financial/${companyId}/invoices`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch invoices:", error);
    throw error;
  }
};

export const fetchInvoiceImage = async (
  bearerToken: string,
  companyId: number,
  invoiceId: number,
): Promise<Blob> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Financial/${companyId}/invoices/${invoiceId}/image`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch invoice image:", error);
    throw error;
  }
};

export const adminFetchInvoiceImage = async (
  bearerToken: string,
  invoiceId: number,
): Promise<Blob> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Admin/invoices/${invoiceId}/image`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
        responseType: "blob",
      },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch invoice image:", error);
    throw error;
  }
};

export const fetchAdminInvoices = async (
  bearerToken: string,
  params?: {
    companyId?: number;
    organizationId?: number;
    year?: number;
    quarter?: number;
    month?: number;
    skip?: number;
    take?: number;
    invoiceNumber?: string;
  },
): Promise<{
  data: Invoice[];
  _count?: number;
}> => {
  try {
    const response = await axiosInstance.get(`${apiUrl}/Admin/invoices`, {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
      },
      params: {
        companyId: params?.companyId,
        organizationId: params?.organizationId,
        year: params?.year,
        quarter: params?.quarter,
        month: params?.month,
        skip: params?.skip,
        take: params?.take,
        invoiceNumber: params?.invoiceNumber,
      },
    });

    // Extract total count from response header
    const totalHeader =
      response.headers["total"] || response.headers["x-total-count"];
    const total = totalHeader ? parseInt(totalHeader, 10) : undefined;

    return { data: response.data, _count: total };
  } catch (error) {
    console.error("Failed to fetch admin invoices:", error);
    throw error;
  }
};
